import { render } from "./IconHamMenu.vue?vue&type=template&id=25262366"
const script = {}
script.render = render

export default script